export const chargeTypeMapping = {
  MISCFEE: "Misc fee",
  LPRENTAL: "Late Payment",
  MAINTENANCE: "Maintenance Fee",
  PROPDAMAGE: "Property Damage",
  TRASHCLEARLARGE: "Trash Clearance fee large items",
  TRASHCLEARSMALL: "Trash Clearance fee small items",
  WRONGSPACE: "Wrong Parking Space Fee",
  IMPRPRKG: "Improper Parking Fee",
  RENTALDAILY: "Daily Rental fee",
  RENTALDEP: "Rental fee deposit",
  RENTALMONTHLY: "Monthly Rental fee",
};

export const MANDATORY_CHARGE_TYPES = [
  'MISCFEE',
  'LPRENTAL',
  'PROPDAMAGE',
  'WRONGSPACE',
  'IMPRPRKG',
  'MAINTENANCE',
  'TRASHCLEARLARGE',
  'TRASHCLEARSMALL',
  'RENTALDAILY',
  'RENTALDEP',
  'RENTALMONTHLY',
];

export const isMandatoryChargeType = (chargeTypeCode) => {
  return MANDATORY_CHARGE_TYPES.includes(chargeTypeCode);
};

export const getChargeTypeDisplayName = (chargeTypeCode) => {
  return chargeTypeMapping[chargeTypeCode] || chargeTypeCode;
};
